





















































































































































































































































































































import { Component, Vue, Watch } from "vue-property-decorator";
import { namespace } from "vuex-class";
import moment from "moment";
import { Support } from "@/http/api/support";
import { SupportHotels } from "@/http/api/v2/supporter/hotels";
import { SupportHotelDetailDto, SupportHotelDto } from "@/http/dto/supportHotel";

const HotelModule = namespace("HotelModule");

@Component
export default class HotelManagement extends Vue {
  @HotelModule.State("hotelObjectId") hotelObjectId!: string;

  deleted = false;
  periodDays = 30;
  loading = false;
  errorMessage = "";
  data: SupportHotelDto[] = [];
  total = 0;
  current = 1;
  keyword = "";
  sortBy = "";
  sortDirection: "asc" | "desc" | "" = "";
  detailVisible = false;
  detailLoading = false;
  detail: SupportHotelDetailDto | null = null;

  get hotelObjectIdValue() {
    return this.hotelObjectId;
  }

  @Watch("hotelObjectIdValue")
  hotelObjectIdChanged() {
    this.current = 1;
    this.load();
  }

  get columns() {
    return [
      {
        title: "호텔",
        key: "name",
        dataIndex: "hotel",
        width: 260,
        fixed: "left",
        sorter: true,
        sortOrder: this.sortOrder("name"),
        scopedSlots: { customRender: "hotel" },
      },
      {
        title: "대표자",
        dataIndex: "owners",
        width: 130,
        scopedSlots: { customRender: "owners" },
      },
      {
        title: "사용자",
        key: "memberCount",
        dataIndex: "users",
        width: 110,
        sorter: true,
        sortOrder: this.sortOrder("memberCount"),
        scopedSlots: { customRender: "users" },
      },
      {
        title: "이슈",
        key: "issueCount",
        dataIndex: "issues",
        width: 120,
        sorter: true,
        sortOrder: this.sortOrder("issueCount"),
        scopedSlots: { customRender: "issues" },
      },
      {
        title: "게시글",
        key: "noticeCount",
        dataIndex: "notices",
        width: 120,
        sorter: true,
        sortOrder: this.sortOrder("noticeCount"),
        scopedSlots: { customRender: "notices" },
      },
      {
        title: "첨부파일",
        key: "storageBytes",
        dataIndex: "storage",
        width: 130,
        sorter: true,
        sortOrder: this.sortOrder("storageBytes"),
        scopedSlots: { customRender: "storage" },
      },
      {
        title: "최근 활동",
        key: "lastActivityTime",
        dataIndex: "activity",
        width: 155,
        sorter: true,
        sortOrder: this.sortOrder("lastActivityTime"),
        scopedSlots: { customRender: "activity" },
      },
      {
        title: "생성일",
        key: "createdTime",
        dataIndex: "createdTime",
        width: 110,
        sorter: true,
        sortOrder: this.sortOrder("createdTime"),
        customRender: (value: string) => moment(value).format("YYYY.MM.DD"),
      },
      {
        title: "관리",
        dataIndex: "action",
        width: 110,
        fixed: "right",
        scopedSlots: { customRender: "action" },
      },
    ];
  }

  get pagination() {
    return {
      total: this.total,
      pageSize: 20,
      current: this.current,
      showTotal: (total: number) => `총 ${this.number(total)}개`,
      showSizeChanger: false,
    };
  }

  get pageActiveUsers() {
    return this.data.reduce((total, hotel) => total + hotel.activeUserCount, 0);
  }

  get pageIssues() {
    return this.data.reduce((total, hotel) => total + hotel.issueCountInPeriod, 0);
  }

  get pageStorageBytes() {
    return this.data.reduce((total, hotel) => total + hotel.storageBytes, 0);
  }

  get pageFileCount() {
    return this.data.reduce((total, hotel) => total + hotel.fileCount, 0);
  }

  sortOrder(key: string) {
    if (this.sortBy !== key || !this.sortDirection) {
      return false;
    }

    return this.sortDirection === "asc" ? "ascend" : "descend";
  }

  mounted() {
    this.load();
  }

  number(value: number) {
    return Number(value || 0).toLocaleString("ko-KR");
  }

  dateTime(value: string) {
    return moment(value).format("YYYY.MM.DD HH:mm");
  }

  formatBytes(value: number) {
    const bytes = Number(value || 0);
    if (bytes === 0) {
      return "0 B";
    }

    const units = ["B", "KB", "MB", "GB", "TB"];
    const unitIndex = Math.min(Math.floor(Math.log(bytes) / Math.log(1024)), units.length - 1);
    const size = bytes / Math.pow(1024, unitIndex);
    return `${size >= 10 || unitIndex === 0 ? size.toFixed(0) : size.toFixed(1)} ${
      units[unitIndex]
    }`;
  }

  momentDate(value: string) {
    return moment(value).format("M/D");
  }

  permissionText(value: string) {
    const labels: { [key: string]: string } = {
      Owner: "마스터",
      Manager: "관리자",
      Member: "사용자",
      Anonymous: "미소속",
    };
    return labels[value] || value;
  }

  permissionColor(value: string) {
    const colors: { [key: string]: string } = {
      Owner: "red",
      Manager: "blue",
      Member: "green",
      Anonymous: "default",
    };
    return colors[value] || "default";
  }

  storageTypeText(value?: string) {
    const labels: { [key: string]: string } = {
      issue: "이슈 첨부",
      notice: "게시글 첨부",
      profile: "프로필",
      hotel: "호텔 이미지",
    };
    return labels[value || ""] || "기타 파일";
  }

  storageHistoryWidth(value: number) {
    if (!this.detail || this.detail.storageHistory.length === 0) {
      return 0;
    }

    const maximum = Math.max(...this.detail.storageHistory.map(item => item.storageBytes), 1);
    return Math.max((value / maximum) * 100, value > 0 ? 3 : 0);
  }

  async openHotel(objectId: string) {
    this.detailVisible = true;
    this.detailLoading = true;
    this.detail = null;
    try {
      this.detail = await SupportHotels.getHotel(objectId);
    } catch (error) {
      this.$message.error("호텔 상세 정보를 불러오지 못했습니다.");
      this.detailVisible = false;
    } finally {
      this.detailLoading = false;
    }
  }

  closeHotel() {
    this.detailVisible = false;
    this.detail = null;
  }

  changeStatus() {
    this.current = 1;
    this.load();
  }

  changePeriod() {
    this.current = 1;
    this.load();
  }

  search() {
    this.current = 1;
    this.load();
  }

  handleTableChange(pagination: any, _filters: any, sorter: any) {
    const nextSortBy = sorter && sorter.order ? String(sorter.columnKey || "") : "";
    const nextSortDirection =
      sorter && sorter.order === "ascend"
        ? "asc"
        : sorter && sorter.order === "descend"
          ? "desc"
          : "";
    const sortChanged =
      nextSortBy !== this.sortBy || nextSortDirection !== this.sortDirection;

    this.sortBy = nextSortBy;
    this.sortDirection = nextSortDirection;
    this.load({ current: sortChanged ? 1 : pagination.current });
  }

  async stopHotel(objectId: string) {
    try {
      await Support.deleteHotel(objectId);
      this.$message.success("호텔이 운영 중지 상태로 변경되었습니다.");
      await this.load();
    } catch (error) {
      this.$message.error("호텔 운영 상태를 변경하지 못했습니다.");
    }
  }

  async recoveryHotel(objectId: string) {
    try {
      await Support.recoveryHotel(objectId);
      this.$message.success("호텔 운영이 복구되었습니다.");
      await this.load();
    } catch (error) {
      this.$message.error("호텔을 복구하지 못했습니다.");
    }
  }

  async load(pagination?: any) {
    try {
      this.loading = true;
      this.errorMessage = "";
      const current = pagination && pagination.current ? pagination.current : this.current;
      const result = await SupportHotels.getHotels({
        page: current,
        take: 20,
        periodDays: this.periodDays,
        keyword: this.keyword || undefined,
        hotelObjectId: this.hotelObjectId || undefined,
        deleted: this.deleted,
        sortBy: this.sortBy || undefined,
        sortDirection: this.sortDirection || undefined,
      });

      this.current = result.page;
      this.total = result.total;
      this.data = result.items;
    } catch (error) {
      this.errorMessage = "호텔 운영 정보를 불러오지 못했습니다. 잠시 후 다시 시도해주세요.";
    } finally {
      this.loading = false;
    }
  }
}
